export default __webpack_public_path__ + "static/media/i_alertas_white.6072d21c.svg";